import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapActions, mapGetters, mapMutations } from "vuex";

@Component({
	computed: {
		...mapGetters([
			"xs",
			"xsOnly",
			"xsAndUp",
			"xsAndDown",
			"sm",
			"smOnly",
			"smAndUp",
			"smAndDown",
			"md",
			"mdOnly",
			"mdAndUp",
			"mdAndDown",
			"lg",
			"lgOnly",
			"lgAndUp",
			"lgAndDown",
			"xl",
			"xlOnly",
			"xlAndUp",
			"xlAndDown",
			"isSmallScreen",

			"getAppCulture",

			"getRequestCount",
			"getIsAnyRequestPanding"
		])
	}
})
export default class baseContextComponent extends Vue {
	getRequestCount: number;
	getIsAnyRequestPanding: boolean;
	getAppCulture: string;

	xs: boolean;
	xsOnly: boolean;
	xsAndUp: boolean;
	xsAndDown: boolean;
	sm: boolean;
	smOnly: boolean;
	smAndUp: boolean;
	smAndDown: boolean;
	md: boolean;
	mdOnly: boolean;
	mdAndUp: boolean;
	mdAndDown: boolean;
	lg: boolean;
	lgOnly: boolean;
	lgAndUp: boolean;
	lgAndDown: boolean;
	xl: boolean;
	xlOnly: boolean;
	xlAndUp: boolean;
	xlAndDown: boolean;
	isSmallScreen: boolean;

	scrollToTop() {
		window.scrollTo(0, 0);
	}
}
